export const OPEN_TEASER_FORM_ADD = "OPEN_TEASER_FORM_ADD";
export const OPEN_TEASER_FORM_EDIT = "OPEN_TEASER_FORM_EDIT";
export const CLOSE_TEASER_FORM = "CLOSE_TEASER_FORM";
export const SET_TEASER_FORM_FIELD = "SET_TEASER_FORM_FIELD";

export const ON_TEASER_FORM_SAVE_SUCCESS = "ON_TEASER_FORM_SAVE_SUCCESS";
export const ON_TEASER_FORM_SAVE_FAILED = "ON_TEASER_FORM_SAVE_FAILED";
export const ON_DELETE_TEASER_SUCCESS = "ON_DELETE_TEASER_SUCCESS";
export const ON_SET_ACTIVE_SUCCESS = "ON_SET_ACTIVE_SUCCESS";
export const ON_SET_INACTIVE_SUCCESS = "ON_SET_INACTIVE_SUCCESS";

export const ON_LOAD_TEASER_SUCCESS = "ON_LOAD_TEASER_SUCCESS";
export const ON_LOAD_TEASER_FAILED = "ON_LOAD_TEASER_FAILED";

export const STATUS_ACTIVE = "active";
export const STATUS_INACTIVE = "inactive";
export const STATUS_MODERATE = "moderation";
export const STATUS_REJECT = "rejected";
export const STATUS_DELETE = 4;

export const ON_LOAD_REMOTE_IMAGE_SUCCESS = "ON_LOAD_REMOTE_IMAGE";
export const ON_LOAD_REMOTE_IMAGE_FAILED = "ON_LOAD_REMOTE_IMAGE_FAILED";

export const ON_LOAD_TEASER_LIST_SUCCESS = "ON_LOAD_TEASER_LIST_SUCCESS";

export const SET_SHOW_LINKS = "SET_SHOW_LINKS";

export const SET_TEASER_CHECKED = "SET_TEASER_CHECKED";
export const SET_TEASER_CHECKED_ALL = "SET_TEASER_CHECKED_ALL";

export const OPEN_STAT_POPUP = "OPEN_STAT_POPUP";
export const CLOSE_STAT_POPUP = "CLOSE_STAT_POPUP";
export const ON_LOAD_TEASER_STAT = "ON_LOAD_TEASER_STAT";

export const ON_TEASER_TMP_IMAGE_UPLOAD_FAILED =
  "ON_TEASER_TMP_IMAGE_UPLOAD_FAILED";
export const ON_TEASER_TMP_IMAGE_UPLOAD_SUCCESS =
  "ON_TEASER_TMP_IMAGE_UPLOAD_SUCCESS";

export const OPEN_TEASER_URL_CHANGE_FORM = "OPEN_TEASER_URL_CHANGE_FORM";
export const CLOSE_TEASER_URL_CHANGE_FORM = "CLOSE_TEASER_URL_CHANGE_FORM";
export const ON_TEASER_URL_CHANGE_FAILED = "ON_TEASER_URL_CHANGE_FAILED";
export const ON_TEASER_URL_CHANGE_SUCCESS = "ON_TEASER_URL_CHANGE_SUCCESS";

export const SET_TEASER_LIST_SORT = "SET_TEASER_LIST_SORT";
export const SET_TEASER_STAT_SORT = "SET_TEASER_STAT_SORT";

export const SET_TEASER_MIN_CPC = "SET_TEASER_MIN_CPC";

export const SET_TEASER_LIST_DATE_RANGE = "SET_TEASER_LIST_DATE_RANGE";

export const SET_STATUS_FILTER = "SET_STATUS_FILTER";
